const $ = require('jquery')
// require('../../bower_components/magnific-popup/dist/jquery.magnific-popup.js')

export const initializeVideoPopup = () => {
  $('.videopopup').magnificPopup({
    type: 'iframe'
  })
}
